import styles from './styles.module.scss';

import { DragItems, DropItems } from '../../types';
import { DropBox } from '../DropBox';

export interface MatrixBoxProps extends React.HTMLAttributes<HTMLDivElement> {
    layout: string[][];
    dropAreas: DropItems[];
    validateOnDrop: any;
    currentEx: number;
    show: any;
}

export const MatrixBox = ({
    layout,
    dropAreas,
    validateOnDrop,
    currentEx,
    show
}: MatrixBoxProps) => {
    const renderDropBox = (item: DropItems) => {
        const key = parseInt(currentEx.toString() + item.id.toString());

        return (
            <div className={styles.boxDropWrapper}>
                <DropBox
                    key={key}
                    className={`${styles.boxDrop}`}
                    items={item as DropItems}
                    onDrop={validateOnDrop}
                    index={show}
                />
            </div>
        );
    };

    const renderRow = (row: string[]) => {
        let matrix: DropItems[] = [];

        row.forEach(column => {
            dropAreas.forEach(dropArea => {
                if (column === dropArea.name) {
                    matrix.push(dropArea);

                    return;
                }
            });
        });

        return <div className={styles.row}>{matrix.map(renderDropBox)}</div>;
    };

    return <div className={styles.wrapper}>{layout.map(renderRow)}</div>;
};
